export default {
  sys: {
    version: "1.0"
  },
  limit: {
    account_length_min: 6,
    account_length_max: 16,
    password_length_min: 6,
    password_length_max: 16
  }
}